import Card from 'antd/lib/card'
import classes from './UserProfile.module.less'
import badgeIcon from '../../../assets/icons/header-badge.svg'
import LogoutIcon from '../../../assets/icons/logout.svg'
import Popover from 'antd/lib/popover'
import DownArrow from '../../../assets/icons/chevron-down.svg'
import { sendAnalyticsTrack } from 'Utils/analytics.utils.ts'
import { useCallback } from 'react'
import { useAuthContext } from 'shared/auth/auth.utils'

export type UserProfileType = {
    userName: string
    userEmail: string
    userId: string
}

export const UserProfile: React.FC<UserProfileType> = (props: UserProfileType) => {
    const { logout } = useAuthContext()
    const handleProfileDropdownClick = useCallback(() => {
        sendAnalyticsTrack('ProfileCTA_Clicked', {
            user_id: props.userId,
        })
    }, [props.userId])

    const handleLogoutIconClick = useCallback(() => {
        sendAnalyticsTrack('LogoutCTA_Clicked', {
            user_id: props.userId,
        })
        logout()
    }, [logout, props.userId])

    const handlePrivacyPolicyIconClick = useCallback(() => {
        window.open(
            'https://www.telusinternational.com/privacy-policy/contributors?INTCMP=ti_privacypolicy_lin[…]data-annotation-solutions-community-data-privacy-notice',
            '_blank',
            'noopener noreferrer'
        )
        sendAnalyticsTrack('PrivacyPolicyCTA_Clicked', {
            user_id: props.userId,
        })
    }, [props.userId])

    return (
        <div className={classes.root} data-testid="user-profile-wrapper">
            <div className={classes.userName}>{props.userName}</div>
            <div>
                <Popover
                    rootClassName={classes.popover}
                    styles={{
                        body: {
                            padding: 0,
                        },
                    }}
                    content={
                        <Card classNames={{ body: classes.cardBody }}>
                            <div className={classes.cardContent}>
                                <div className={classes.cardContent1}>{props.userName}</div>
                                <div className={classes.cardContent2}>{props.userEmail}</div>
                                <div className={classes.settings}>
                                    <div className={classes.settingsText}>
                                        <img src={badgeIcon} alt="Badge" />
                                        <button
                                            data-testid="privacy-policy"
                                            onClick={() => handlePrivacyPolicyIconClick()}
                                        >
                                            Privacy Policy
                                        </button>
                                    </div>
                                    <div className={classes.settingsText}>
                                        <img src={LogoutIcon} alt="Logout" />
                                        <button
                                            data-testid="logout"
                                            onClick={() => handleLogoutIconClick()}
                                        >
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    }
                    trigger="click"
                    placement={'bottomLeft'}
                >
                    <button
                        data-testid="analytics"
                        onClick={() => handleProfileDropdownClick()}
                        className={classes.downArrow}
                    >
                        <img src={DownArrow} alt="Down" />
                    </button>
                </Popover>
            </div>
        </div>
    )
}
